class CollectionsTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.collections-tabs__button');
    this.panels = container.querySelectorAll('.collections-tabs__panel');
    this.init();
  }

  init() {
    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    const targetPanelId = clickedTab.getAttribute('aria-controls');

    // Remove active state from all tabs and panels
    this.tabs.forEach((tab) => {
      tab.classList.remove('collections-tabs__button--active');
      tab.setAttribute('aria-selected', 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('collections-tabs__panel--active');
      panel.hidden = true;
    });

    // Add active state to clicked tab and corresponding panel
    clickedTab.classList.add('collections-tabs__button--active');
    clickedTab.setAttribute('aria-selected', 'true');

    const targetPanel = this.container.querySelector(`#${targetPanelId}`);
    if (targetPanel) {
      targetPanel.classList.add('collections-tabs__panel--active');
      targetPanel.hidden = false;
    }
  }
}

// Initialize tabs when DOM is ready
function initCollectionsTabs() {
  const tabsContainers = document.querySelectorAll('.collections-tabs');
  tabsContainers.forEach((container) => {
    if (!container.dataset.initialized) {
      new CollectionsTabs(container);
      container.dataset.initialized = 'true';
    }
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionsTabs);
} else {
  initCollectionsTabs();
}

// Re-initialize on section load (for Shopify theme editor)
document.addEventListener('shopify:section:load', () => {
  initCollectionsTabs();
});

